import {
  IconButton,
  Typography,
  CardMedia,
  LinearProgress,
  Grid,
  Tooltip,
  Button,
  Theme,
  Hidden,
  Stack,
  Stepper,
  styled,
  StepConnector,
  stepConnectorClasses,
  Step,
  StepButton,
  StepLabel,
  StepIconProps,
  StepIcon,
  useTheme,
  Dialog,
} from '@mui/material';
import { Box } from '@mui/system';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Link as RouterLink, useParams } from 'react-router-dom';
import {
  getApplicationDetails,
  nonIndividualFormValidForSubmission,
  updateApplication,
} from '../../redux-store/actions/application';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { RejectedDetails } from '../ApplicationDetails';
import { AmlDetails, CommonLayout, ConfirmationDialog } from '../commonComponents';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {
  APPLICATION_STATUS,
  USER_ROLES,
  ApplicationStatusBasedOnRole,
  REJECTED_ROLES,
  IndividualApplicationStatusBasedOnRole,
  APPLICATION_LISTING_STATUS,
  APPLICATION_TYPE,
  PHYSICAL_DIGITAL_FLOW,
  ONBOARDING_DEMAT_DETAILS,
} from '../../utils/constant';
import { formatShortDateAndTime } from '../../utils/date';
import { checkIfApplicationIsNonIndividual } from '../../utils/utilityFunctions';
import ContributorDetails from './ContributorDetails';
import { RootStateType } from '../../redux-store/reducers';
import ContactDetails from './ContactDetails';
import InvestAndPaymentDetails from '../ApplicationDetails/InvestmentAndPayment';
import BankDetails from '../ApplicationDetails/BankDetails';
import AuthorizedSignatories from './AuthorisedSignatories';
import Documents from './Document';
import Ubo from './ubo';
import Fatca from './fatca';
import { useRouteMatch } from 'react-router';
import DistributorDetails from '../ApplicationDetails/rmDetails';
import RiskProfile from './RiskProfile';
import InvPref from './InvPref';
import { DialogCloseIcon, EditIcon, StepperSuccessIcon } from '../../assets/SvgIcons';
import Comments from '../ApplicationDetails/Comments';
import * as yup from 'yup';
import { Formik } from 'formik';
import { MFTextField } from '../../lib/formik';
import { LoadingButton } from '@mui/lab';
import RMConcentForBSE from '../ApplicationDetails/rmConsentBse';
import DematDetails from '../ApplicationDetails/DematDetails';
import InvestmentPreference from '../ApplicationDetails/investmentPreferenceDetails';
import DuplicatePanApplications from '../ApplicationDetails/DuplicatePanApplications';

const NonIndividualMenuItemList = [
  'Distributor Details',
  'Contributor Details',
  'Contact Details',
  // 'Investment & Payment Details',
  "Investor's Bank Details",
  ...(ONBOARDING_DEMAT_DETAILS ? ["Investor's DP Details"] : []),
  'Authorised Signatory',
  'Declaration of UBO',
  'FATCA',
  // 'Risk Profile',
  // 'Investment Preference',
  'Document Details'
  // 'Risk Profile',
];


const NonIndividualMenuItemListLink = [
  'distributor-details',
  'personal-details',
  'contact-details',
  // 'investment-payment-details',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ["dp-details"] : []),
  'authorised-signatory',
  'declaration-ubo',
  'fatca',
  // 'risk-profile',
  // 'investment-preference',
  'document-details',
  // 'risk-profile',
];

const BootstrapStepConnector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.line}`]: {
    flexDirection: "column",
    height: 5,
    borderLeftWidth: "1px",
    borderLeftColor: `${theme.palette.text.secondary}26`,
    borderLeftStyle: "solid"
  },
}));
export const NonIndividualApplicationLayout = ({
  loading,
  application,
  setDuplicatePanApplicationCount = () => { return; },
  setDuplicatePanCheckboxValue = () => { return; },
  duplicatePanCheckboxValue = false
}: {
  loading: boolean;
  application: ApplicationProps;
  setDuplicatePanApplicationCount?: Dispatch<SetStateAction<number>>;
  setDuplicatePanCheckboxValue?: Dispatch<SetStateAction<boolean>>;
  duplicatePanCheckboxValue?: boolean;
}): JSX.Element => {
  const { onboardingVia = '' } = application || {};
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  return (
    <>
      {loading && <LinearProgress />}
      {/* {application && (
        <>
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
            }}
            mb={3}>
            <Box sx={{ p: 2 }}>
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  mb={2}>
                  <Typography
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                    }}>
                    Application ID: {application.applicationNumber}
                  </Typography>
                  {application.clientCode && (
                    <Typography
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: 'text.secondary',
                      }}>
                      Client Code : {application.clientCode}
                    </Typography>
                  )}
                  <Typography
                    className={
                      application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                          ? role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                          : !checkIfApplicationIsNonIndividual(application) &&
                            role === USER_ROLES.AMCAPPROVER
                            ? IndividualApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                    }
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                      '&.Draft .MuiTypography-root': {
                        color: 'rgba(51, 127, 201, 0.7)',
                      },
                      '&.Completed .MuiTypography-root': {
                        fontWeight: 600,
                        color: 'rgba(35, 133, 63, 0.7)',
                      },
                      '&.Rejected .MuiTypography-root': {
                        color: '#BD2932',
                        fontWeight: 500,
                      },
                    }}>
                    Status:{' '}
                    <Typography
                      component="span"
                      sx={{
                        color: '#B78813',
                        fontSize: '16px',
                        letterSpacing: '0.4px',
                        ml: 0.5,
                      }}>
                      {application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                          ? role === USER_ROLES.AMCAPPROVER
                            ? ApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]
                          : !checkIfApplicationIsNonIndividual(application) &&
                            role === USER_ROLES.AMCAPPROVER
                            ? IndividualApplicationStatusBasedOnRole[role][application.status]
                            : APPLICATION_LISTING_STATUS[application.status]}
                    </Typography>
                  </Typography>
                  {[
                    USER_ROLES.RM,
                    USER_ROLES.OPE,
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.SUBDISTRIBUTOR,
                    USER_ROLES.AMCAPPROVER,
                    USER_ROLES.AMC_ADMIN,
                  ].includes(role) &&
                    application.signedLeegalityFile?.url && (
                      <Tooltip title={'Download'}>
                        <IconButton
                          sx={{
                            p: 0,
                            pr: 0.5,
                            ':hover': {
                              bgcolor: '#F4FCFC',
                            },
                            cursor: 'pointer',
                            pointerEvents: 'all',
                          }}
                          onClick={() =>
                            application.signedLeegalityFile?.url &&
                            window.open(application.signedLeegalityFile?.url)
                          }>
                          <CardMedia
                            component="img"
                            src={'/images/download-icon.png'}
                            alt="Download"
                            sx={{ width: '25px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                </Grid>
                {application.status === 'rejected' && (
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={1}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <RejectedDetails
                      title={'Rejected by'}
                      description={REJECTED_ROLES[application.rejectedByRole]}
                    />
                    <RejectedDetails
                      title={'Rejected on'}
                      description={formatShortDateAndTime(application.rejectedAt)}
                    />
                    <RejectedDetails
                      title={'Reason for rejection'}
                      description={application.rejectedReason}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box>
          <AmlDetails
            applicants={application.applicants}
            applicationType={application.applicationType}
          />
          <DistributorDetails application={application} />
          <ContributorDetails applicants={application.applicants} />
          <ContactDetails applicants={application.applicants} />
          <InvestAndPaymentDetails application={application} />
          <BankDetails banks={application.banks} />

          <AuthorizedSignatories groups={application.groups} />
          <Ubo application={application} />
          <Fatca applicants={application.applicants} />
          <RiskProfile application={application} />
          <InvPref application={application} />
          <Documents application={application} />

        </>
      )} */}
      {application && (
        <>
          {PHYSICAL_DIGITAL_FLOW && (
            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.text.primary, mb: '9px' })}>
              {`Onboarding Type : ${onboardingVia?.toUpperCase()}`}
            </Typography>
          )}
          <RMConcentForBSE application={application} />

          <AmlDetails
            applicants={application.applicants}
            applicationType={application.applicationType}
          />
          {application?.comments?.length > 0 && (
            <Comments application={application} />
          )}
          <div id="distributor-details">
            <DistributorDetails application={application} />
          </div>
          <div id="personal-details">
            <ContributorDetails applicants={application.applicants} />
          </div>
          <div id="contact-details">
            <ContactDetails applicants={application.applicants} />
          </div>
          {/* <div id="investment-payment-details"></div>
          <InvestAndPaymentDetails application={application} /> */}

          <div id="bank-details">
            <BankDetails banks={application.banks} />
          </div>
          {ONBOARDING_DEMAT_DETAILS && (
            <div id="dp-details">
              <DematDetails demats={application.demats} />
            </div>
          )}
          <div id="authorised-signatory">
            <AuthorizedSignatories groups={application.groups} />
          </div>
          <div id="declaration-ubo">
            <Ubo application={application} />
          </div>
          <div id="fatca">
            <Fatca applicants={application.applicants} />
          </div>
          {/* <div id="risk-profile">
            <RiskProfile application={application} />
          </div> */}
          {/* <div id="investment-preference">
            <InvPref application={application} />
          </div> */}
          {/* <div id="investment-preference">
            <InvestmentPreference application={application} />
          </div> */}
          <div id="document-details">
            <Documents application={application} />
          </div>
          {[USER_ROLES.AMCAPPROVER].includes(`${role ?? ""}`.toLowerCase() as USER_ROLES) && (
            <Box mt={5}>
              <DuplicatePanApplications
                application={application}
                setDuplicatePanApplicationCount={setDuplicatePanApplicationCount}
                setDuplicatePanCheckboxValue={setDuplicatePanCheckboxValue}
                duplicatePanCheckboxValue={duplicatePanCheckboxValue}
              />
            </Box>
          )}
        </>
      )}
    </>
  );
};

//Read only view for RM, Distributor, Subdistributor
export const NonIndividualApplicationDetail = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState<ApplicationProps>();
  const applicationDetailRef = useRef<HTMLDivElement>();
  const [openDialog, setDialog] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { path, url } = useRouteMatch();


  const routerUrl = url.substring(0, url.lastIndexOf('/'))

  //new 
  const { application: applicationDetail } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { currentStep } = applicationDetail || {};

  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  const handleSendBack = () => setOpenSendBackDialog(true);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);


  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        const _application = (await dispatch(
          getApplicationDetails(id)
        )) as unknown as ApplicationProps;
        if (!isComponentActive) return;
        setApplication(_application);
      } catch (e) {
        console.log(e);
      } finally {
        if (isComponentActive) setLoading(false);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  const { editable, applicationSentBack = false } = application || {};

  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const onSendBackSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      const { id, status } = application || {};
      if (id) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              status: 'sent_to_amc_approver',
              comment: values.comment,
              applicationSentBack: false,
            },
            applicationId: id,
          })
        );
        history.push('/applications');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const { id } = application || {};
      setIsSubmitting(true);
      if (id) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              status: 'sent_to_amc_approver'
            },
            applicationId: id,
          })
        );
        history.push('/applications');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isNIOAppPreview = path.includes('non-individual-application-preview');

  return (
    <CommonLayout>
      <>
        <Box component={'div'} style={{ marginBottom: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 8px' }}>
          {path === "/non-individual-application-preview/:id" ? (
            <Typography variant='h1' sx={{ color: 'text.primary' }}>
              {/* {application?.onboardingType?.toLowerCase() === "minor" ?
                `Minor Investor Onboarding ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                ""
              } */}
              {application?.onboardingType?.toLowerCase() === "minor" ?
                `Minor Investor Onboarding` :
                ""
              }
              {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                `Individual Investor Onboarding ${application?.accountType ?
                  '(' + application?.accountType + ')' : ''}` :
                ""
              } */}
              {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                `Individual Investor Onboarding` :
                ""
              }
              {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                `Non Individual Investor Onboarding ${application?.accountType ?
                  '(' + application?.accountType + ')' : ''}` :
                ""
              } */}
              {(application?.onboardingType?.toLowerCase() === "normal" &&
                application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                `Non Individual Investor Onboarding` :
                ""
              }
            </Typography>
          ) : (
            <Box>
              <Typography
                variant='h1'
                sx={{ color: 'text.primary' }}
              >
                Application Details
              </Typography>
              {path === "/non-individual-application-details/:id" ? (
                <Typography variant='h2' sx={{ color: 'text.primary', marginTop: "20px" }}>
                  {/* {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor ${[USER_ROLES.AMC_ADMIN].includes(role) ? '' : 'Onboarding'} ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor ${[USER_ROLES.AMC_ADMIN].includes(role) ? '' : 'Onboarding'}` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor ${[USER_ROLES.AMC_ADMIN].includes(role) ? '' : 'Onboarding'} ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor ${[USER_ROLES.AMC_ADMIN].includes(role) ? '' : 'Onboarding'}` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor ${[USER_ROLES.AMC_ADMIN].includes(role) ? '' : 'Onboarding'} ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor ${[USER_ROLES.AMC_ADMIN].includes(role) ? '' : 'Onboarding'}` :
                    ""
                  }
                </Typography>
              ) : (
                <Typography variant='h2' sx={{ color: 'text.primary', marginTop: "20px" }}>
                  {/* {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {application?.onboardingType?.toLowerCase() === "minor" ?
                    `Minor Investor` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
                    `Individual Investor` :
                    ""
                  }
                  {/* {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor ${application?.accountType ?
                      '(' + application?.accountType + ')' : ''}` :
                    ""
                  } */}
                  {(application?.onboardingType?.toLowerCase() === "normal" &&
                    application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
                    `Non Individual Investor` :
                    ""
                  }
                </Typography>
              )}
            </Box>
          )}
          {path === "/non-individual-application-preview/:id" && <Typography sx={{ fontWeight: '500', fontSize: 16, letterSpacing: '0.02px', color: 'text.primary' }}>{`Application ID: ${application?.applicationNumber}`}</Typography>}
        </Box>
        <Grid container sx={(theme: Theme) => ({
          p: "35px",
          border: `1px solid ${theme.palette.text.secondary}26`,
          borderRadius: "15px",
          background: theme.palette.background.paper,
          position: 'relative'
        })}>
          <Hidden lgDown={true}>
            <Grid item xs={12} lg={3} sx={{ padding: 0, position: 'sticky', top: '18px' }}>
              <Stack sx={{ position: 'sticky', top: '18px', pl: 4, py: 3, display: { lg: 'block', xl: 'block' } }}>
                {/* Stepper */}
                <Stepper
                  activeStep={currentStep ?? 0}
                  orientation="vertical"
                  connector={<BootstrapStepConnector />}
                  sx={{
                    "&.MuiStepper-vertical": {
                      ".MuiStepButton-vertical": {
                        ".MuiStepLabel-vertical": {
                          paddingTop: "0px",
                          paddingBottom: "0px"
                        }
                      }
                    }
                  }}
                >
                  {NonIndividualMenuItemList &&
                    NonIndividualMenuItemList.map((item, index) => {
                      const isItemDisabled = !currentStep ? index !== 0 : index > currentStep;

                      return <Step key={index}>
                        <StepButton
                          href={`#${NonIndividualMenuItemListLink[index]}`}
                        // onClick={() => routerUrl !== '/application-details' ? !isItemDisabled &&
                        //   history.replace(
                        //     `${application &&
                        //     (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                        //       ? `/application/${NonIndividualMenuItemListLink[index]}`
                        //       : `/application/${MenuItemListLink[index]}`)
                        //     }`,
                        //     {
                        //       id: application.id,
                        //       applicant1ReferenceId: application.applicant1ReferenceId,
                        //     }
                        //   ) : null
                        // }
                        >
                          <StepLabel
                            sx={(theme: Theme) => ({
                              "& .MuiStepLabel-label.Mui-completed": {
                                ...theme.typography.body_500,
                                color: theme.palette.text.secondary,
                              },
                              "& .MuiStepLabel-label.Mui-active": {
                                ...theme.typography.body_500,
                                color: theme.palette.primary[500]
                              },
                              "& .MuiStepLabel-label.Mui-disabled": {
                                ...theme.typography.body_500,
                                color: theme.palette.text.secondary,
                              },
                              "& .MuiStepLabel-iconContainer.Mui-active": {
                                "& .MuiStepIcon-root.Mui-active": {
                                  color: theme.palette.primary[500]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.textDark.primary
                                }
                              },
                              "& .MuiStepLabel-iconContainer.Mui-disabled": {
                                "& .MuiStepIcon-root": {
                                  color: theme.palette.grey[100]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.text.secondary
                                }
                              }
                            })}
                            StepIconComponent={({ completed, ...props }: StepIconProps) => (
                              <StepIcon {...props} icon={completed ? <StepperSuccessIcon /> : props.icon} />
                            )}
                          >
                            {item}
                          </StepLabel>
                        </StepButton>
                      </Step>
                    })}
                </Stepper>

              </Stack>
            </Grid>
          </Hidden>
          <Grid item
            container
            md={12}
            lg={9}
            sx={(theme: Theme) => ({
            })}
          >
            <Box component={'div'} style={{ padding: '35px', border: `1px solid ${theme.palette.text.secondary}26`, borderRadius: '15px', backgroundColor: `${theme.palette.common.white}`, width: '100%' }}>
              <Box
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 5, columnGap: '20px' }}
                ref={applicationDetailRef}>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  {path === "/non-individual-application-preview/:id" ? (
                    <>
                      <IconButton
                        sx={{ height: 'fit-content', p: 0 }}
                        component={RouterLink}
                        to="/applications">
                        <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                      </IconButton>

                      <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                        Summary
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', }}>
                        <Box >

                          <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                            <Typography
                              variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                            >
                              Application ID:{' '}
                            </Typography>
                            <Typography
                              variant="inherit"
                              sx={{
                                fontWeight: '400',
                                fontSize: 20,
                                display: 'inline',
                                color: 'text.primary',

                              }}
                            >
                              {application?.applicationNumber}
                            </Typography>
                          </Typography>

                          <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                            <Typography
                              variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                            >
                              Status:{' '}
                            </Typography>
                            <Typography
                              variant="inherit"
                              sx={(theme: Theme) => ({
                                fontWeight: '400',
                                fontSize: 20,
                                display: 'inline',
                                color: application?.status === 'draft' ? theme.palette.primary[500] : theme.palette.warning[500],
                                textTransform: 'capitalize'

                              })}
                            >
                              {APPLICATION_LISTING_STATUS[application?.status ?? ""] ?? ""}
                            </Typography>
                          </Typography>

                        </Box>
                        {application?.clientCode &&
                          <Box>
                            <Typography component={'div'} variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', mb: 1 }}>
                              <Typography
                                variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px', display: 'inline' }}
                              >
                                Client Code:{' '}
                              </Typography>
                              <Typography
                                variant="inherit"
                                sx={{
                                  fontWeight: '400',
                                  fontSize: 20,
                                  display: 'inline',
                                  color: 'text.primary',

                                }}
                              >
                                {application?.clientCode}
                              </Typography>
                            </Typography>
                          </Box>
                        }
                      </Box>

                    </>
                  )
                  }

                  {/* <IconButton
                    sx={{ height: 'fit-content', p: 0 }}
                    component={RouterLink}
                    to="/applications">
                    <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
                  </IconButton>
                  <Typography variant='h2' sx={{ color: 'text.primary', letterSpacing: '0.01px' }}>
                    Summary
                  </Typography> */}
                </Box>
                {editable && (!isNIOAppPreview) && (
                  // <IconButton>
                  //   <CardMedia
                  //     component="img"
                  //     src="/images/edit-icon-outlined.svg"
                  //     alt="Edit Icon"
                  //     sx={{ width: 'unset' }}
                  //     onClick={() => history.push(`/application`, { id })}
                  //   />
                  // </IconButton>
                  ![USER_ROLES.AMC_ADMIN].includes(role) && <Button
                    variant="outlined"
                    startIcon={<EditIcon />}
                    sx={(theme: Theme) => ({
                      padding: '15px',
                      border: `0.5px solid ${theme.palette.text.secondary}`,
                      borderRadius: '10px',
                      color: theme.palette.text.secondary,
                      fontFamily: theme.typography.fontFamily,
                      fontSize: '18px',
                      fontWeight: 700,
                      cursor: 'pointer',

                    })}
                    onClick={() => history.push(`/non-individual-application`, { id })}
                  >
                    Edit
                  </Button>
                )}
              </Box>
              <NonIndividualApplicationLayout
                loading={loading}
                application={application as ApplicationProps}
              />
              {/* {path === '/application-preview/:id' && editable && (
                <Box sx={{ textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    sx={(theme: Theme) => ({
                      color: 'common.white',
                      // minWidth: '200px',
                      minWidth: "457px",
                      mt: 4,
                      // fontWeight: 600,
                      // lineHeight: 1.5,
                      // fontSize: '16px',
                      ...theme.typography.body_700
                    })}
                    onClick={async () => {
                      (sendApplication_Nri(application) ||
                        (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))) &&
                        applicationSentBack
                        ? handleSendBack()
                        : setDialog(true);
                    }}
                    disabled={isSubmitting || sendBackLoading}>
                    {`${application?.hasPOA
                      ? 'Send to POA Approver'
                      : sendApplication_Nri(application) ||
                        (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
                        ? 'Send to Checker'
                        : 'Send to Investor'
                      } ${isSubmitting || sendBackLoading ? '...' : ''}`}
                  </Button>
                </Box>
              )} */}
              {path === '/non-individual-application-preview/:id' && editable && (
                <Grid container spacing={2} sx={{ mt: 4 }}>
                  <Grid item xs={12} md={6}>
                    {![USER_ROLES.AMC_ADMIN].includes(role) && <Button
                      variant="outlined"
                      startIcon={<EditIcon />}
                      sx={(theme: Theme) => ({
                        padding: '15px',
                        border: `0.5px solid ${theme.palette.text.secondary}`,
                        borderRadius: '10px',
                        color: theme.palette.text.secondary,
                        fontFamily: theme.typography.fontFamily,
                        fontSize: '18px',
                        fontWeight: 700,
                        cursor: 'pointer',
                        width: '100%',

                      })}
                      onClick={() => history.push(`/non-individual-application`, { id })}
                    >
                      Edit
                    </Button>
                    }
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Button
                      variant="contained"
                      sx={(theme: Theme) => ({
                        color: 'common.white',
                        // minWidth: "457px",
                        // mt: 4,
                        width: '100%',
                        ...theme.typography.body_700
                      })}
                      onClick={async () => {
                        applicationSentBack
                          ? handleSendBack()
                          : setDialog(true);
                      }}
                      disabled={isSubmitting || sendBackLoading}>
                      {`${'Send to Checker'} ${isSubmitting ? '...' : ''}`}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Grid>
        </Grid>
        <IconButton
          sx={{
            position: 'fixed',
            right: 0,
            bottom: 75,
            borderRadius: '5px  0 0 5px',
            '&,:hover': {
              bgcolor: 'primary.main',
            },
          }}
          onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
        </IconButton>


        {/* <ConfirmationDialog
          message={'Are you sure you want to send it to Checker?'}
          open={openDialog}
          setOpen={() => setDialog(false)}
          onSave={async () => {
            setDialog(false);
            handleSubmit();
          }}
          onCancel={() => setDialog(false)}
        /> */}

        <Dialog
          onClose={handleSendBackClose}
          open={openSendBackDialog}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
            <DialogCloseIcon />
          </IconButton>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 18,
                fontWeight: 500,
                textAlign: 'justify',
              },
            }}>
            <Typography
              sx={{ color: 'primary.main', mt: 2 }}>{`Are you sure you want to send it to Checker ?`}</Typography>
            <Typography sx={{ color: 'primary.main', mt: 2 }}>Provide comments *</Typography>
            <Formik
              initialValues={initialCommentValues}
              onSubmit={onSendBackSubmit}
              validationSchema={Commentvalidation}>
              {({ handleSubmit }) => (
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <MFTextField
                    name="comment"
                    multiline
                    rows={4}
                    placeholder="Type your answer here..."
                  />

                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <LoadingButton
                      loading={sendBackLoading}
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 400,
                      }}
                      type="submit">
                      Yes
                    </LoadingButton>
                    <Button
                      onClick={() => {
                        handleSendBackClose();
                      }}
                      variant="outlined"
                      sx={{
                        fontSize: 15,
                        color: 'primary.main',
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                      }}
                      disabled={sendBackLoading}>
                      No
                    </Button>
                  </Grid>
                </Box>
              )}
            </Formik>
          </Box>
        </Dialog>
        <ConfirmationDialog
          message={`Sending details to Checker`}
          subMessage={`Are you sure you want to send it to Checker ?`}
          open={openDialog}
          setOpen={() => setDialog(false)}
          onSave={async () => {
            setDialog(false);
            handleSubmit();
          }}
          onCancel={() => setDialog(false)}
        />
      </>
    </CommonLayout>
  );
};
